import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6stq13nzkh: FaireBrandEntity = {
  token: "b_6stq13nzkh",
  type: "brand",
  name: "Electrum Group Holdings LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/c67ed58b6f2edd4326522062cb3b138d0fd6a8afaaefaa0b3437f134f772559e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/50c85ada59372a5e70b9cc1a859b328969a26cf162552813058b2d378f7453fa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c67ed58b6f2edd4326522062cb3b138d0fd6a8afaaefaa0b3437f134f772559e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/50c85ada59372a5e70b9cc1a859b328969a26cf162552813058b2d378f7453fa.jpeg",
  location: "Astoria , NY, USA",
  minimumOrderDollars: 49,
  rating: 4.5,
  reviewCount: 17,
  isInsider: true,
  description:
    "Y-to-the-O! YOYO World is a trend forward industry leader creating, manufacturing, distributing tween to teen focused products through Wholesale, Retail and Direct to Consumer channels. Our categories include bath, cosmetics, compounds, DIY, essentials, Emergency goods, and toys. We began with a utility patent for retractable lip gloss that you clip on to your hip or bag - YOYO Lip Gloss. With YOYO World, we bring you all things loved! We have expanded into a world of endless fun and possibilities including DIY Slime Kits, Novelty and Beauty, Toy and Impulse, Ready-made compounds and licensed toys. New to the YOYO Family is YOYO Fun - we deliver all things loved right to your door! For the last decade and beyond, we strive to promote individuality, creativity and discovery through fun while inspiring kindness and awareness through the practice of giving back to those in need around the world.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:19.048Z",
    importedBy: "entity-db-cli",
  },
};
